<template>
	<div>
		<div class="my-2" v-for="(val, i) in value" :key="i">
			<!-- * switch pour alterner entre colonne/valeur -->
			<div class="flex">
				<div class="mr-2" :class="value[i].col ? 'opacity-25' : ''">
					Valeurs
				</div>
				<b-form-checkbox switch v-model="value[i].col">
				</b-form-checkbox>
				<div :class="!value[i].col ? 'opacity-25' : ''">Colonne</div>
			</div>
			<!-- * Champs -->
			<div class="flex justify-evenly">
				<input
					:placeholder="value[i].col ? 'colonne' : fieldName"
					class="input-color bg-transparent shadow rounded border-t-0 border-r-0 border-l-0 focus:outline-none focus:shadow-outline focus:border-gray-400 focus:border-b-2"
					:class="value[i].col ? 'w-[90%]' : 'w-[45%]'"
					type="text"
					v-model="value[i].parameter" />
				<input
					v-if="!value[i].col"
					placeholder="valeur"
					class="input-color bg-transparent w-[55%] shadow rounded border-t-0 border-r-0 border-l-0 focus:outline-none focus:shadow-outline focus:border-gray-400 focus:border-b-2"
					type="text"
					v-model="value[i].value" />
				<span class="cursor-pointer" @click="() => value.splice(i, 1)">
					<i class="fa fa-times" aria-hidden="true"></i>
				</span>
			</div>

			<!-- * description -->
			<b-form-textarea
				placeholder="description"
				class="mt-2 w-[90%] break-normal input-color bg-transparent shadow rounded border-t-0 border-r-0 border-l-0 focus:outline-none focus:shadow-outline focus:border-gray-400 focus:border-b-2"
				type="text"
				v-model="value[i].description">
			</b-form-textarea>
		</div>
		<!-- * button pour ajouter des parametres  -->
		<div>
			<b-button
				class="m-md-2"
				variant="outline-primary"
				@click="
					() =>
						value.push({
							parameter: '',
							value: '',
							description: '',
							col: false,
						})
				">
				Nouveau {{ fieldName }}
			</b-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: "config_champs_requete",
		props: {
			value: {
				type: Array,
			},
			fieldName: {
				type: String,
			},
		},
		computed: {
			inputVal: {
				get() {
					return this.value;
				},
				set(val) {
					this.$emit("input", val);
				},
			},
		},
	};
</script>
